import type { SxProps, Theme } from "@mui/material";
import { Stack, useTheme } from "@mui/material";
import type { CustomMeasureReturnType } from "../../customMeasure/hooks/useCustomMeasure";
import FunctionPropertyItemWrapper from "./FunctionPropertyItemWrapper";
import VariablePropertyItemWrapper from "./VariablePropertyItemWrapper";

interface Props {
  state: CustomMeasureReturnType;
  sx?: SxProps<Theme>;
}

export const Properties = ({ state, sx }: Props) => {
  const { palette } = useTheme();
  return (
    <Stack
      spacing={2}
      useFlexGap
      sx={{
        width: "100%",
        overflow: "unset",
        "& .MuiSvgIcon-root": {
          color: palette.secondary.light,
        },
        "& .Mui-checked, .MuiCheckbox-indeterminate": {
          "& .MuiSvgIcon-root": {
            color: palette.primary.main,
          },
        },
        ...sx,
      }}
    >
      {state.formulaNodes.map((fn, i) => {
        if (fn.function !== undefined) {
          return (
            <FunctionPropertyItemWrapper key={`${fn.key}-fn-${fn.text}`} formulaNode={fn} state={state} index={i} />
          );
        }
        return <VariablePropertyItemWrapper key={`${fn.key}-${fn.text}`} formulaNode={fn} state={state} index={i} />;
      })}
    </Stack>
  );
};
